import { useMutation } from '@tanstack/react-query';

import useGlynt from './useGlynt';

export default function useRerenderDocumentPages(dpid: string, documentId: string) {
  const glynt = useGlynt(dpid);

  return useMutation<void, Error>({
    mutationFn: async () => (await glynt).document.rerenderPages(documentId),
  });
}
